var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vuestic-layout",class:_vm.classObject},[_vm._t("default"),_c('div',{staticClass:"content-wrap no-padding",attrs:{"id":"content-wrap"}},[_vm._t("content")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }